module.exports = __webpack_public_path__ + "media/img/frontend_application/single-data-icon-06bdc355d76d71f532752ace232c73cd.png";